export const ORIGINAL_VIDEO_ID = 'original-video';
export const UPLOAD_SCREENSHARE_ID = 'upload-screenshare';
